const Colors = {
    white: "#fff",
    black: "#000",
    green: "#009B7F",
    milk: "#F6F9FC",
    blue: "#6498E6",
    purple: "#DF4FB4",
    gray1: "#C2CDD9",
    gray2: "#81858b",
    red: "#D0332C",
    dark: "#19212E",
    pink: "#FF2460",
    orange: "#FFA200"
};
export default Colors;